module.exports = __webpack_public_path__ + "img/kanban.1f5dde63.svg";